function* getColumns(columns, columnTypeRequirement) {
  for (const key of Object.keys(columns)) {
    const colType = columns[key].datatype;
    if (typeof columnTypeRequirement === "string") {
      if (colType === columnTypeRequirement)
        yield key; // it's for backward compatibility: colType should be an object with 'type', string colTypes are deprecated
      else
        switch (columnTypeRequirement) {
          case "numeric":
            if (colType && ["number", "integer", "natural"].includes(colType.type))
              yield key;
            break;
          case "enum":
            if (colType && colType.type === "enum")
              yield key;
            break;
          case "boolean":
            if (colType && (colType.type === "boolean" || (colType.type === "enum" && colType.values.length === 2)))
              yield key;
            break;
          case "string":
            if (colType && colType.type === "string")
              yield key;
            break;
          default:
            console.error(`Unknown columnType requirement "${columnTypeRequirement}"`);
        }
    } else {
      if (JSON.stringify(colType) === JSON.stringify(columnTypeRequirement))
        yield key;
    }
  }
}

function* generate(columns, signature) {
  if (!Array.isArray(signature)) throw new Error(`A signature ${signature} must be an array`);
  if (signature.length === 0) return yield [];
  const [firstColumnTypeReq, ...restSignature] = signature;
  for (const firstColumn of getColumns(columns, firstColumnTypeReq)) {
    for (const restContext of generate(columns, restSignature)) {
      yield [firstColumn, ...restContext];
    }
  }
}

export default function generateContextBySignature(columns, signature) {
  return [...generate(columns, signature)];
}
